export const DELIVERY_LIST_REQUEST = 'DELIVERY_LIST_REQUEST';
export const DELIVERY_LIST_SUCCESS = 'DELIVERY_LIST_SUCCESS';
export const DELIVERY_LIST_FAIL = 'DELIVERY_LIST_FAIL';

export const DELIVERY_LIST_SAVE_REQUEST = 'DELIVERY_LIST_SAVE_REQUEST';
export const DELIVERY_LIST_SAVE_SUCCESS = 'DELIVERY_LIST_SAVE_SUCCESS';
export const DELIVERY_LIST_SAVE_FAIL = 'DELIVERY_LIST_SAVE_FAIL';
export const DELIVERY_LIST_SAVE_RESET = 'DELIVERY_LIST_SAVE_RESET';
